module.exports = __webpack_public_path__ + "static/media/skin_repo.f6279fc7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/books/skin_repo.svg
// module id = 403
// module chunks = 0